import {Typography} from 'components/Typography';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {REVIEWS_CODE, VIVINO_CODE} from 'modules/product-card/constants';
import {selectProductData} from 'modules/product-card/selectors';
import {FC, useMemo} from 'react';
import style from './style.module.scss';
import {useIsProductFineAndRare} from 'modules/product-card/hooks/useIsProductFineAndRare';
import {ProductRatingsItem} from 'modules/product-card/components/ProductRatingsItem';

export const ProductRatings: FC = () => {
    const isFineAndRareCategory = useIsProductFineAndRare();
    const productData = useAppSelector(selectProductData);
    const {ratings} = productData || {};

    const reviewRatings = useMemo(() => {
        if (!ratings) {
            return [];
        }

        const excludeList = [REVIEWS_CODE];

        if (isFineAndRareCategory) {
            excludeList.push(VIVINO_CODE);
        }

        return ratings.filter(({code}) => !excludeList.some((excludeCode) => excludeCode === code));
    }, [isFineAndRareCategory, ratings]);

    if (!reviewRatings.length) {
        return null;
    }

    return (
        <div className={style.main}>
            <Typography className={style.ratingsTitle} data-skeleton-item={true}>
                Рейтинги экспертов
            </Typography>
            <div className={style.ratingBody}>
                {reviewRatings.map(({code, value}) => (
                    <ProductRatingsItem key={code} code={code} value={value} />
                ))}
            </div>
        </div>
    );
};
